import { ConditionIcons, WeatherInfoDisplay } from 'components';
import DataGridDisplay from 'components/DataGridDisplay/DataGridDisplay';
import { WeatherContext } from 'pages/Forecast';
import React, { useContext, useEffect, useState } from 'react';
import { FaWind } from 'react-icons/fa';
import 'styles/global.css';
import { GetWeatherDateString } from 'utils/stringUtils';
import styles from './DetailedForecast.module.css';

export default function DetailedForecast({ selectedDay }) {
  const weatherContext = useContext(WeatherContext);

  const [filtered, setFiltered] = useState();
  const [segmentData, setSegmentData] = useState({
    morning: null,
    afternoon: null,
    evening: null,
    night: null,
  });

  const getFilteredData = () => {
    if (!weatherContext.detailed) return [];

    return weatherContext.detailed.filter((item) => item.weekday === selectedDay);
  };

  useEffect(() => {
    setFiltered(getFilteredData());
  }, [weatherContext?.detailed, selectedDay]);

  useEffect(() => {
    if (!filtered) return;

    const morning = filtered.find((d) => d.segment === 'M');
    const afternoon = filtered.find((d) => d.segment === 'A');
    const evening = filtered.find((d) => d.segment === 'E');
    const night = filtered.find((d) => d.segment === 'N');

    setSegmentData({
      morning,
      afternoon,
      evening,
      night,
    });
  }, [filtered]);

  // If there's no data for the selected day, render a safe placeholder
  if (!filtered || filtered.length === 0) {
    return (
      <div className={styles['root']}>
        <h1>Detailed Forecast</h1>
        <p>No detailed forecast data available for the selected day.</p>
      </div>
    );
  }

  const getSegmentStr = (segment) => {
    try {
      switch (segment) {
        case 'M':
          return 'Morning';
        case 'A':
          return 'Afternoon';
        case 'E':
          return 'Evening';
        case 'N':
          return 'Night';
        default:
          return '';
      }
    } catch (error) {
      console.error('Error in getSegmentStr:', error);
      return '';
    }
  };

  const DaySegmentShort = ({ data }) => {
    return (
      <div className={styles['content-vertical']}>
        <div>{getSegmentStr(data.segment)}</div>
        <div className={styles['content-vertical-icon']}>
          <ConditionIcons conditionId={parseInt(data?.icon || '0')} size={100} />
          <div>{`${data.temperature}°F`}</div>
        </div>
        <div className={styles['content-vertical-row']}>
          <ConditionIcons conditionId={18} size={30} />
          <div>{`${data?.precip_prob}%`}</div>
        </div>
        <div className={styles['content-vertical-row']}>
          <FaWind size={20} />
          <div>{`${data?.precip_prob}%`}</div>
        </div>
      </div>
    );
  };

  return (
    <div className={[styles['root'], 'overflow-hidden']}>
      {/* Section 1 Spread (Horizontal) */}
      <div>
        <DataGridDisplay
          title={`${GetWeatherDateString(new Date(filtered[0]?.iso8601))} Detailed Forecast`}
        >
          <div className={styles['display-container']}>
            {filtered.map((data, index) => (
              <DaySegmentShort key={data?.iso8601 || index} data={data} />
            ))}
          </div>
        </DataGridDisplay>
      </div>

      {/* Section 2 Spread (Grid) */}
      <div className={[styles['content-grid'], 'overflow-hidden']}>
        {segmentData?.morning && <WeatherInfoDisplay data={segmentData.morning} title="Morning" />}
        {segmentData?.afternoon && (
          <WeatherInfoDisplay data={segmentData.afternoon} title="Afternoon" />
        )}
        {segmentData?.evening && <WeatherInfoDisplay data={segmentData.evening} title="Evening" />}
        {segmentData?.night && <WeatherInfoDisplay data={segmentData.night} title="Night" />}
      </div>
    </div>
  );
}
